import React from "react";
import { Icon } from "@iconify/react";
import iconoWhatsapp from "@iconify/icons-mdi/whatsapp";
import { CELULAR, NOMBRE_NEGOCIO } from "../../../constants/negocio";
import style from "../../../styles/landing.module.scss";

const MENSAJE_WHATSAPP = `Hola, quiero información sobre ${NOMBRE_NEGOCIO}.`;

// Botón que abre un chat de WhatsApp (+57) con el mensaje precargado.
// styleGroup permite variantes (ej. botón compacto del encabezado)
const BotonWhatsappComponent = ({ children, styleGroup = "" }) => {
    const enlace = `https://wa.me/57${CELULAR}?text=${encodeURIComponent(MENSAJE_WHATSAPP)}`;

    return (
        <a
            href={enlace}
            target="_blank"
            rel="noopener noreferrer"
            className={`${style.boton_whatsapp} ${styleGroup}`}
        >
            <Icon icon={iconoWhatsapp} aria-hidden="true" /> {children}
        </a>
    );
};

export default BotonWhatsappComponent;
